import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './pdp-recommend-size_types.2';

export function getPdpRecommendSize(variable: types.GetPdpRecommendSizeVariables, options?: GqlRequestOptions) {
  const query = 'query GetPdpRecommendSize($catalog_product_id: ID!) { pdp_recommend_group(catalog_product_id: $catalog_product_id) { ... on PDPRecommendGroup { bottom_area_size } } }';
  return gql_request<types.GetPdpRecommendSize, types.GetPdpRecommendSizeVariables>('GetPdpRecommendSize', query, variable, { use_consumer: true, ...options });
}

